import { request } from '@/util/http'

// export const getData = (params) => {
//   return request({
//     url: '/dataSplice/getData',
//     method: 'post',
//     data: params
//   })
// }

export const getData = (wxUserId) => {
  return request({
    url: '/dataSplice/getData',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getDataLossWeight = (wxUserId) => {
  return request({
    url: '/dataSplice/getDataLossWeight',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getDataBlood = (wxUserId) => {
  return request({
    url: '/dataSplice/getDataBlood',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getBloodDataSplice = (params) => {
  return request({
    url: '/dataSplice/getBloodDataSplice',
    method: 'post',
    data: params
  })
}
